import { render, staticRenderFns } from "./system_school_infomation.vue?vue&type=template&id=3259fccf&scoped=true"
import script from "./system_school_infomation.vue?vue&type=script&lang=js"
export * from "./system_school_infomation.vue?vue&type=script&lang=js"
import style0 from "./system_school_infomation.vue?vue&type=style&index=0&id=3259fccf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3259fccf",
  null
  
)

export default component.exports